/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Dispatched_Many_ToastInputs */

const en_chat_dispatched_many_toast = /** @type {(inputs: Chat_Dispatched_Many_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tasks dispatched by the LLM.`)
};

const fr_chat_dispatched_many_toast = /** @type {(inputs: Chat_Dispatched_Many_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tâches dispatchées par le LLM.`)
};

const ms_sg2_chat_dispatched_many_toast = /** @type {(inputs: Chat_Dispatched_Many_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tugasan dilancarkan oleh LLM.`)
};

/**
* | output |
* | --- |
* | "{count} tasks dispatched by the LLM." |
*
* @param {Chat_Dispatched_Many_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_dispatched_many_toast = /** @type {((inputs: Chat_Dispatched_Many_ToastInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dispatched_Many_ToastInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_dispatched_many_toast(inputs)
	if (locale === "fr") return fr_chat_dispatched_many_toast(inputs)
	return ms_sg2_chat_dispatched_many_toast(inputs)
});